import(/* webpackMode: "eager" */ "/home/user/studio/src/app/photos/page.tsx");
